var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('SiteMasthead',{attrs:{"title":"Recent Sales","mini":"true"}}),_c('ContentRow',[_c('ContentContainer',[_c('Listings',{attrs:{"filter":_vm.listingFilter}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }